import jsCookie, { CookieAttributes } from 'js-cookie';

import { isString } from '../../util/guards';

const cookieAttributes: CookieAttributes = {
  domain: 'wix.com',
  path: '/contact',
  expires: 1 / 48, // in 30 minutes
};

class Cookie {
  set(key: string, value: unknown): void {
    jsCookie.set(key, String(value), cookieAttributes);
  }

  get(key: string): string | undefined {
    return jsCookie.get(key);
  }

  remove(key: string): void {
    jsCookie.remove(key, cookieAttributes);
  }

  has(key: string): boolean {
    return isString(this.get(key));
  }

  is(key: string, value: string): boolean {
    return this.get(key) === value;
  }
}

export const cookie = new Cookie();
